import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

export default class extends Controller {
  static targets = ["teamSelect"]
  static values = { url: String }

  connect() {
    this.initChoices()
  }

  disconnect() {
    if (this.choices) {
      this.choices.destroy()
    }
  }

  initChoices() {
    if (this.hasTeamSelectTarget) {
      this.choices = new Choices(this.teamSelectTarget, {
        shouldSort: false,
        searchEnabled: true,
        itemSelectText: '',
        noResultsText: '見つかりませんでした',
        noChoicesText: '選択肢がありません',
      })
    }
  }

  filter() {
    const teamId = this.teamSelectTarget.value
    
    if (!this.urlValue) return
    const baseUrl = new URL(this.urlValue, window.location.origin)
    
    baseUrl.searchParams.set('team_id', teamId)

    const form = this.element.closest('form')
    if (form) {
      const checkedWorkers = form.querySelectorAll('input[name="schedule_entries_form[worker_ids][]"]:checked')
      checkedWorkers.forEach(cb => {
        baseUrl.searchParams.append('worker_ids[]', cb.value)
      })
    }

    const frame = document.getElementById("workers_list")
    if (frame) {
      frame.src = baseUrl.toString()
    }
  }
}
